export var GitIntegrationStatus;
(function (GitIntegrationStatus) {
    GitIntegrationStatus["GIT_INTEGRATION_STATUS_CONNECTED"] = "CONNECTED";
    GitIntegrationStatus["GIT_INTEGRATION_STATUS_REVOKED"] = "REVOKED";
    GitIntegrationStatus["GIT_INTEGRATION_STATUS_DEGRADED"] = "DEGRADED";
})(GitIntegrationStatus || (GitIntegrationStatus = {}));
